import { useState, useEffect } from "react"
import Modal from "../Modal/Modal"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import SubmissionResult from "../SubmissionResult/SubmissionResult"
import ContactUsForm from "./ContactUsForm"
import { useTranslation } from "react-i18next"

const ContactUs = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  const [statusMessage, setStatusMessage] = useState(null)
  const [statusError, setStatusError] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setStatusMessage(null)
      setStatusError(false)
    }
  }, [isOpen])

  const handleSuccess = msg => {
    setStatusMessage(msg)
    setStatusError(false)
  }

  const handleError = msg => {
    setStatusMessage(msg)
    setStatusError(true)
  }

  const renderContent = () => {
    if (statusMessage) {
      return (
        <SubmissionResult
          error={statusError}
          message={statusMessage}
          title={statusError ? t("Error") : t("Thanks")}
          buttonText={t("close")}
          onButtonClick={onClose}
        />
      )
    }
    
    const recaptchaEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED === "true";

    return recaptchaEnabled ? (
      
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      >
        <ContactUsForm
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </GoogleReCaptchaProvider>
    ) : (
      <ContactUsForm
          onSuccess={handleSuccess}
          onError={handleError}
        />
    )
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel=""
      large
      ariaHideApp={true}
      hideHeaderAndClose={false}
      shouldFocusAfterRender={true}
      role="dialog"
      aria-modal="true"
      disableEnforceFocus={true}
    >
      {renderContent()}
    </Modal>
  )
}

export default ContactUs
